import { type FormikTouched } from 'formik';

import type * as Yup from 'yup';

import {
  type FieldElement,
  type FormValues,
  type ValidationRule,
} from '../../../../shared/types';
import { type EntityInitialData } from '../../data-store';

export type LocalizeFn = (
  defaultMessage: string,
  placeholders?: object
) => string;

export type FieldSchema = Yup.Schema<unknown>;

export interface ValidatorContext {
  field: FieldElement;
  l: LocalizeFn;
  isRequired: boolean;
  requiredMessage?: string;
  currentValues?: FormValues;
  touched?: FormikTouched<FormValues>;
  entityData?: EntityInitialData | null;
}

export interface ExpressionContext {
  values: FormValues;
  touched?: FormikTouched<FormValues>;
  entityData?: EntityInitialData | null;
}

/**
 * Safely get validations from a field
 */
export const getFieldValidations = (field: FieldElement): ValidationRule[] => {
  if ('validations' in field && Array.isArray(field.validations)) {
    return field.validations;
  }

  return [];
};

/**
 * Find a validation rule by type
 */
export const findValidation = (
  validations: ValidationRule[],
  type: string
): ValidationRule | undefined => validations.find((rule) => rule.type === type);

/**
 * Check if a validation exists
 */
export const hasValidation = (
  validations: ValidationRule[],
  type: string
): boolean => validations.some((rule) => rule.type === type);
